module.exports = "/_next/static/media/feed.16b3ceef.png";